import {Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[tisaCarouselItem]',
  standalone: false,
})
export class CarouselItemDirective {
  constructor(readonly elementRef: ElementRef<HTMLElement>) {}
}
